import {
    ConsentLevel,
    ScriptLoadResult,
    useScriptWithConsent,
} from '@news-mono/web-common'
import React from 'react'
import { ConsentFallback } from '../../tracking/ConsentFallback/ConsentFallback'
import { EmbedProps } from './Embed'
import { StyledEmbed } from './Embed.styled'

const consentRequiredLevel = ConsentLevel.Analytics | ConsentLevel.Advertising

export const Embedly: React.FC<EmbedProps> = ({ link }) => {
    const [embedRef, setEmbedRef] = React.useState<HTMLAnchorElement | null>(
        null,
    )
    const [result, scriptLoadError] = useScriptWithConsent({
        consentRequiredLevel,
        consentMet: {
            src: 'https://cdn.embedly.com/widgets/platform.js',
        },
    })

    React.useEffect(() => {
        if (result === ScriptLoadResult.Success && checkEmbedly() && embedRef) {
            embedly('card', embedRef)
        }
    }, [result, embedRef])

    if (scriptLoadError) {
        return null
    }

    if (result === ScriptLoadResult.NotConsented) {
        return <ConsentFallback />
    }

    /**
     * The .js-embed className is used for manual triggering embedly in preview mode
     * We can't use the "official" class .embedly-card as embedly's autodetection
     * would interfere with our rendering in React and sometimes cause race conditions
     */
    return (
        <StyledEmbed className={getClassName(link)} embedLink={link}>
            <a
                href={link}
                ref={(ref) => setEmbedRef(ref)}
                className="js-embed"
                data-card-key="2ac17161f707456d853e010bafc56489"
                data-card-controls="0"
                data-card-width="100%"
            >
                Loading content...
            </a>
        </StyledEmbed>
    )
}
Embedly.displayName = 'Embedly'

function getClassName(link: string) {
    const BASE_EMBED = 'embed'

    if (link.indexOf('spotify.com') >= 0) {
        return `spotify-embed ${BASE_EMBED}`
    }

    return BASE_EMBED
}

function checkEmbedly() {
    return typeof embedly !== 'undefined'
}
